import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { useAPIErrorHandler } from '../../../components/hooks/useAPIErrorHandler';
import { queries } from '../../../queries';
import { transformToOption } from '../../../utils/functional/fp';
import type { SelectOption } from '../../../types/components/common';
import type { MessageInfoLabel } from '../../../api/cmail.api';

export const useGetLabels = () => {
  const handleAPIError = useAPIErrorHandler();

  const query = useQuery({
    ...queries.cmail.labels(),
    onError: handleAPIError('Unable to fetch labels'),
  });

  const labels = React.useMemo(() => {
    if (!query.data) {
      return [];
    }

    return query.data.map(
      transformToOption(
        (data) => data.label,
        (data) => data.value
      )
    ) as SelectOption<MessageInfoLabel>[];
  }, [query.data]);

  return { query, labels };
};
